import apiClient from "@/utils/axios.js";
import {useHttpErrorManager} from "@/composables/useHttpErrorManager.js";

export function useAppHelpers() {

    const togglePassword = (element) => {
        if (element) {
            element.onclick = () => {
                var passwordInputs =
                    document.querySelectorAll(".password-input");
                passwordInputs.forEach((elem) => {
                    if (elem.type === "password") {
                        elem.type = "text";
                        element.classList.remove("bx-show");
                        element.classList.add("bx-hide");
                    } else {
                        elem.type = "password";
                        element.classList.remove("bx-hide");
                        element.classList.add("bx-show");
                    }
                });
            };
        }
    };

    const switchClasses = (element, addClass, removeClass) => {
        if (element) {
            element.classList.add(addClass);
            element.classList.remove(removeClass);
        }
    };

    const htmlDecode = (data) => {
        var txt = document.createElement("textarea");
        txt.innerHTML = data;
        return txt.value;
    };

    const htmlEncode = (input) => {
        const textArea = document.createElement("textarea");
        textArea.innerText = input;
        return textArea.innerHTML.split("<br>").join("\n");
    };
    
    const arraysAreEqual = (arr1, arr2) => {
        if(arr1 === undefined && arr2 === undefined){
            return true;
        }
        else if(arr1 === undefined || arr2 === undefined){
            return false;
        }
        else if (arr1.length !== arr2.length) {
            return false;
        }
        
        return arr1.every((value, index) => value === arr2[index]);
    }

    const deleteAllCookies = (cookieName = "", path = "") => {
        const cookies = document.cookie.split(";");
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i];
            const eqPos = cookie.indexOf("=");
            const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;

            if (cookie === "" || cookieName.trim() === name.trim()) {
            } else {
                continue;
            }
            deleteCookie(name, path);
        }
    };

    const deleteCookie = (name, path = "") => {
        if (path === "") {
            document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT";
            document.cookie =
                name.trim() + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT";
            document.cookie =
                name + "=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
            document.cookie =
                name.trim() +
                "=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
        } else {
            document.cookie =
                name +
                "=; path=" +
                path +
                "; expires=Thu, 01 Jan 1970 00:00:00 GMT";
            document.cookie =
                name.trim() +
                "=; path=" +
                path +
                "; expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }
    };

    const getCookie = (name) => {
        const cookies = document.cookie.split(";");
        for (const cookie of cookies) {
            const [key, value] = cookie.split("=");
            if (key.trim() === name) {
                return decodeURIComponent(value.trim());
            }
        }
        return "";
    };

    const formatBytes = (bytes, decimals = 2) => {
        if (!+bytes) return "0 Bytes";

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${
            sizes[i]
        }`;
    };

    const timeAgo = (date) => {
        date = date.trim();
        if (!date.endsWith(".000000Z")) {
            date += ".000000Z";
        }
        if (date.indexOf(" ") >= 0) {
            date = date.replace(/\s+/g, "T");
        }

        const seconds = Math.floor(
            (new Date().valueOf() - new Date(date).valueOf()) / 1000
        );

        let interval = Math.floor(seconds / 31536000);
        if (interval >= 1) {
            return interval + " years ago";
        }

        interval = Math.floor(seconds / 2592000);
        if (interval >= 1) {
            return interval + " months ago";
        }

        interval = Math.floor(seconds / 86400);
        if (interval >= 1) {
            return interval + " days ago";
        }

        interval = Math.floor(seconds / 3600);
        if (interval >= 1) {
            return interval + " hours ago";
        }

        interval = Math.floor(seconds / 60);
        if (interval >= 1) {
            return interval + " minutes ago";
        }

        if (seconds < 10) return "just now";

        return Math.floor(seconds) + " seconds ago";
    };

    const getProfilePic = (link = "", fullname = "Test User") => {
        if (!link) {
            let name = fullname
                .split(" ")
                .map((segment) => segment.trim().substring(0, 1))
                .join(" ")
                .trim();
            return (
                "https://ui-avatars.com/api/?name=" +
                encodeURIComponent(name) +
                "&color=7F9CF5&background=31445A"
            );
        }
        return link;
    };

    const copyText = (text) => {
        if (navigator.clipboard) {
            navigator.clipboard
                .writeText(text)
                .then(() => {})
                .catch((err) => {});
        } else {
            const tempTextArea = document.createElement("textarea");
            tempTextArea.value = text;
            document.body.appendChild(tempTextArea);
            tempTextArea.select();
            tempTextArea.setSelectionRange(0, 99999);
            document.execCommand("copy");
            document.body.removeChild(tempTextArea);
        }
    };

    const phoneNumberFormatter = (val) => {
        let cleanNumber = val.replace(/[\t\s_\-\(\)\[\]\{\}]/g, "");
        cleanNumber = cleanNumber.replace(/\D/g, "");
        cleanNumber = cleanNumber.trim();

        if (cleanNumber.length === 10) {
            cleanNumber = "+1" + cleanNumber;
        }

        if (cleanNumber.length === 11 && !cleanNumber.startsWith("+")) {
            cleanNumber = `+1 ${cleanNumber.slice(1, 4)}-${cleanNumber.slice(
                4,
                7
            )}-${cleanNumber.slice(7)}`;
            return cleanNumber;
        } else if (cleanNumber.length === 12 && cleanNumber.startsWith("+")) {
            const withoutPlus = cleanNumber.slice(1);
            cleanNumber = `+1 ${withoutPlus.slice(1, 4)}-${withoutPlus.slice(
                4,
                7
            )}-${withoutPlus.slice(7)}`;
            return cleanNumber;
        } else {
            return val;
        }
    };

    const statusFormatter = (val) => {
        return val.toLowerCase().replace(/\b\w/g, (s) => s.toUpperCase());
    };

    const dateFormatter = (val) => {
        if (val) {
            let date = new Date(val);
            return date.toLocaleDateString();
        }
        return "";
    };

    const dateTimeFormatter = (val) => {
        if (val) {
            let date = new Date(val);
            return date.toLocaleDateString() + " " + date.toLocaleTimeString();
        }
        return "";
    };

    const toSingular = (word) => {
        const rules = [
            { plural: /ies$/, singular: 'y' },
            { plural: /es$/, singular: '' },
            { plural: /s$/, singular: '' },
        ];

        for (const rule of rules) {
            if (word.match(rule.plural)) {
                return word.replace(rule.plural, rule.singular);
            }
        }

        return word;
    };

    const gdprText = () => {
        return `
        <div class='text-start'>
            <ul>
                <li>I am at least 16 years old or older.</li>
                <li>I have read and agree to the <a href='/terms' target='_blank'>Terms & Conditions</a> and <a href='/privacy' target='_blank'>Privacy Policy</a>.</li>
                <li>I understand and agree that my survey answers may be publicly displayed.</li>
                <li>I understand and agree that my survey answers may be subject to automated decision-making</li>
            </ul>
        </div>`;
    };

    const loaderOn = (elem, toggleDisplay = false, lowerOpacity = true) => {
        if(elem){
            elem.classList.add("loading");
            elem.style.opacity = "1";
            if(lowerOpacity){
                // elem.style.opacity = "0.6";
                elem.style.filter = "brightness(0.6)";
            }
            if(toggleDisplay){
                elem.classList.remove("d-none");
            }
        }

    };

    const loaderOff = (elem, toggleDisplay = false) => {
        if(elem){
            elem.classList.remove("loading");
            // elem.style.removeProperty("opacity");
            elem.style.removeProperty("filter");
            if(toggleDisplay){
                elem.classList.add("d-none");
            }
        }
    };
    
    const extractTwoFactorConnectionCode = (otpAuthUrl) => {
        const url = new URL(otpAuthUrl.replace('otpauth://', 'http://'));
        return url.searchParams.get('secret');
    }

    const checkTwoFAStatus = async (email) => {
        let twoFactorType = 'none';
        let twoFAStatus = false;
        let twoFAActivated = false;
        let twoFAEmailStatus = false;
        let twoFAEmailActivated = false;

        try {
            let url = '/auth/user/two-factor-status';
            let data = {};
            if(email){
                url = '/auth/user/two-factor-status-email';
                data = { email : email };
            }
            const response = await apiClient.post(url, data);
            if (response.status === 200) {
                twoFactorType = response.data.two_factor_type;
                if(response.data.two_factor_type === 'app'){
                    twoFAStatus = response.data.two_factor_status;
                    twoFAActivated = response.data.two_factor_activated;

                    twoFAEmailStatus = false;
                    twoFAEmailActivated = false;
                }
                else if(response.data.two_factor_type === 'email'){
                    twoFAEmailStatus = response.data.two_factor_status;
                    twoFAEmailActivated = response.data.two_factor_activated;

                    twoFAStatus = false;
                    twoFAActivated = false;
                }
                else{
                    twoFAStatus = false;
                    twoFAActivated = false;

                    twoFAEmailStatus = false;
                    twoFAEmailActivated = false;
                }
            }

        } catch (error) {
            twoFAStatus = false;
            twoFAEmailStatus = false;
            twoFAEmailActivated = false;
            twoFAActivated = false;

            await useHttpErrorManager().handleError(error, true);

        }

        let twoFAActivateStatus = twoFAEmailActivated || twoFAActivated;
        twoFAStatus = twoFAStatus || twoFAEmailStatus;
        return { 'twoFAActivate' : twoFAActivateStatus, 'twoFAStatus' : twoFAStatus,  'twoFactorType' : twoFactorType };
    }
    
    const visitTracker = async (type, specific, path) => {
        const key = `${type}:${specific}`;
        let visitedPages = localStorage.getItem('visitedPages') ? JSON.parse(localStorage.getItem('visitedPages')) : [];
        if(!Array.isArray(visitedPages)) visitedPages = [];
        if(!visitedPages.includes(key)) {
            visitedPages.push(key);
            // Cap the array size to avoid unbounded growth
            if(visitedPages.length > 500){
                visitedPages = visitedPages.slice(-500);
            }
            localStorage.setItem('visitedPages', JSON.stringify(visitedPages));
            try {
                await apiClient.post('/helper/trackPageVisit', {
                    page: path,
                    specific: specific,
                    type: type,
                    visited_at: new Date().toISOString()
                });
            } catch (error) {
                await useHttpErrorManager().handleError(error, false);
            }
        }
    };
    
    return {
        togglePassword,
        switchClasses,
        htmlDecode,
        htmlEncode,
        deleteAllCookies,
        deleteCookie,
        getCookie,
        formatBytes,
        timeAgo,
        getProfilePic,
        copyText,
        phoneNumberFormatter,
        statusFormatter,
        dateFormatter,
        dateTimeFormatter,
        toSingular,
        gdprText,
        loaderOn,
        loaderOff,
        checkTwoFAStatus,
        extractTwoFactorConnectionCode,
        arraysAreEqual,
        visitTracker
    };
}
